import * as React from "react";

interface Props {
  options?: IntersectionObserverInit;
  onAppear(): void;
}

class Intersection extends React.Component<Props> {
  private targetRef: HTMLElement | null = null;
  private observer?: IntersectionObserver;

  constructor(props: Props) {
    super(props);
  }

  public componentDidMount() {
    const options: IntersectionObserverInit = this.props.options || {
      root: null,
      rootMargin: "0px",
      threshold: 1.0,
    };
    this.observer = new IntersectionObserver(this.handleObserver, options);
    this.observer.observe(this.targetRef!);
  }

  public componentWillUnmount() {
    this.observer!.disconnect();
  }

  public setRef = (ref: HTMLElement | null) => {
    this.targetRef = ref;
  };

  public handleObserver: IntersectionObserverCallback = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.target === this.targetRef) {
        this.props.onAppear();
      }
    });
  };

  // [NOTE(kobayang)]
  // In Edge, The actions by intersection do not fire on empty div.
  public render() {
    return <div ref={this.setRef} style={{ height: "1px" }} />;
  }
}

export default Intersection;



// WEBPACK FOOTER //
// ./frontend/src/common/components/lazy/Intersection.tsx